import { styled } from "@mui/material";
import React from "react";
const StyledDivieder = styled("div")(({ theme }) => ({
  padding: 1,
  background: "black",
}));
export default function MDDivider() {
  return <StyledDivieder />;
}
